import * as TYPES from './actions/types';

export const initialState = {
  registrationDetails: {},
  reminderSettings: {
    reminderSettings: {
      reminderSettingId: 1,
      patientDefaultFollowUpReminderOffset: '',
      patientFollowUpEmailEnabled: false,
      patientFollowUpSmsEnabled: false,
      patientAppointmentEmailEnabled: false,
      patientDefaultAppointmentReminderOffset: '',
      patientAppointmentSmsEnabled: false,
      patientSecureMessageEmailEnabled: false,
      patientSecureMessageSmsEnabled: false,
      patientQuestionnaireEmailEnabled: false,
      patientQuestionnaireSmsEnabled: false,
    },
    followupReminderOffsets: [],
    appointmentReminderOffsets: [],
  },
  patientReminderSettings: {
    appointmentReminderOffset: '',
    followUpReminderOffset: '',
    followUpEmailEnabled: false,
    appointmentEmailEnabled: false,
    secureMessageEmailEnabled: false,
    questionnaireEmailEnabled: false,
    usePrimaryEmail: false,
    nonPrimaryEmailAddress: '',
    emailBounced: false,
    followUpSmsEnabled: false,
    appointmentSmsEnabled: false,
    secureMessageSmsEnabled: false,
    questionnaireSmsEnabled: false,
    smsPhoneNumber: '',
  },
  notificationEmail: {
    email: null,
  },
};

export const accountSettingsReducer = (state = initialState, action) => {
  let newState;
  const changedProperty = {};
  switch (action.type) {
    case TYPES.PATIENT_REGISTRATION_DETAILS_LOAD_SUCCESS:
      newState = { ...state, registrationDetails: action.details };
      break;
    case TYPES.LOAD_REMINDERSETTINGS:
      newState = { ...state, reminderSettings: action.reminderSettings };
      break;
    case TYPES.LOAD_PATIENT_REMINDERSETTINGS:
      newState = { ...state, patientReminderSettings: action.patientReminderSettings };
      break;
    case TYPES.SET_NOTIFICATION_EMAIL:
      {
        const newNotificationEmail = { ...state.notificationEmail, email: action.email };

        newState = { ...state, notificationEmail: newNotificationEmail };
      }
      break;
    case TYPES.UPDATE_NOTIFICATION_FORMINPUT:
      if (action.formInput.inputName === 'nonPrimaryEmailAddress') {
        changedProperty.usePrimaryEmail =
          action.formInput.value === state.registrationDetails.primaryEmail;
        changedProperty[action.formInput.inputName] =
          changedProperty.usePrimaryEmail ? null : action.formInput.value;
      } else {
        changedProperty[action.formInput.inputName] = action.formInput.value;
      }
      newState = { ...state,
        patientReminderSettings: { ...state.patientReminderSettings,
          ...changedProperty } };

      break;
    case TYPES.DISABLE_APPOINTMENTSMS:
      newState = { ...state,
        patientReminderSettings: { ...state.patientReminderSettings,
          appointmentSmsEnabled: false } };
      break;
    default:
      newState = state;
      break;
  }

  return newState;
};

export default accountSettingsReducer;
